import api from '@/api/api'

const state = {
    suppliers: [],
    distributors: [],
    providerTypes: []
};

const getters = {
    getSuppliers: state => state.suppliers,
    getDistributors: state => state.distributors,
    getProviderTypes: state => state.providerTypes,
};

const mutations = {
    EMPTY_SUPPLIERS (state) {
        state.suppliers = []
    },
    EMPTY_DISTRIBUTORS (state) {
        state.distributors = []
    },
    EMPTY_PROVIDER_TYPES (state) {
        state.providerTypes = []
    },
    FETCH_SUPPLIERS(state, supplier) {
        state.suppliers.push(supplier)
    },
    FETCH_DISTRIBUTORS(state, distributor) {
        state.distributors.push(distributor)
    },
    FETCH_PROVIDERS_TYPE(state, types) {
        state.providerTypes.push(types)
    }
};

const actions = {
    async fetchSuppliers({commit}) {
        commit('EMPTY_SUPPLIERS')
        api.fetchSuppliers().then(res => {
            res.data.data.forEach(sup => {
                commit('FETCH_SUPPLIERS', sup)
            })
        })
    },

    async fetchDistributors({commit}) {
        commit('EMPTY_DISTRIBUTORS')
        api.fetchDistributors().then(res => {
            res.data.data.forEach(dist => {
                commit('FETCH_DISTRIBUTORS', dist)
            })
        })
    },

    async fetchProviderTypes({commit}) {
        commit('EMPTY_PROVIDER_TYPES')
        api.fetchProviderTypes().then(res => {
            res.data.data.forEach(type => {
                commit('FETCH_PROVIDERS_TYPE', type);
            })
        })
    },

    async addSupplier({commit}, payload) {
        console.log(payload);
        commit('FETCH_SUPPLIERS', payload);
    },

    async addDistributor({commit}, payload) {
        commit('FETCH_DISTRIBUTORS', payload);
    },

    async updateProviderData({commit}, payload) {
        if (payload.provider_type_id === 1) {
            const updatedData = state.distributors.filter(dist => {
                return dist.id === payload.id
            });

            updatedData.map(e => {
                return e = payload;
            });
        } else {
            const updatedData = state.suppliers.filter(supp => {
                return supp.id === payload.id
            });

            updatedData.map(e => {
                return e = payload;
            });
        }

    }
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/providers.js